
const DEFAULT_PREFERENCES = {
    minDateCutoff: null
};

const STORAGE_KEY = "galileoPreferences"

export function getPreferences() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
        try {
            return JSON.parse(stored)
        } catch(e) {
            console.log('Error retrieving preferences from storage', e)
        }
    }
    return DEFAULT_PREFERENCES;
}

export function setPreferences(newPref) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newPref))
}